
export default {
    props: {
        data: Number,
    },
    methods: {
        tempChange(n: number): void {
            //funkcja zmieniająca wartość temperatury o + lub - 1
            (this as any).$emit("tempChange", n);
        },
        setTemp(n: number): void {
            //tu powinno zostać wykonane żądanie z UPDATE do serwera z nową wartością temperatury
            console.log(n);
        },
    },
};
